import axios from '@/plugins/axios'

const state = {
    usertoken: localStorage.getItem('token') || '',
}

const getters = {
    usertoken(state) {
        return state.usertoken
    },
    userinfo(state) {
        let b64DecodeUnicode = str =>
          decodeURIComponent(
            Array.prototype.map.call(atob(str), c =>
              '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            ).join(''))

        let parseJwt = token =>
          JSON.parse(
            b64DecodeUnicode(
              token.split('.')[1].replace('-', '+').replace('_', '/')
            )
          )
        if (!state.usertoken) {
            return {}
        }
        return parseJwt ( state.usertoken )
    },
    isLoggedIn(state) {
        return state.usertoken !== ''
    }
}

const actions = {
    setToken({commit}, token) {
        localStorage.setItem('token', token)
        axios.defaults.headers.Authorization = `Bearer ${token}`
        commit('LOGIN', {token})
    },
    async login({
        commit
    }, event) {
        let loginResponse = await axios({
            url:'/auth/login',
            method: 'POST',
            data: {
                email: event.target[0].value,
                password: event.target[1].value
            }
        })
        if (!loginResponse.data && !loginResponse.data.token) {
            return false
        }
        localStorage.setItem('token', loginResponse.data.token)
        axios.defaults.headers.Authorization = `Bearer ${loginResponse.data.token}`
        commit('LOGIN', {token: loginResponse.data.token})
        return true
    },
    async impersonate({dispatch}, userId) {
        let response = await axios.post(`/auth/impersonate/${userId}`)
        await dispatch('setToken', response.data.token)
    },
    async stopImpersonation({dispatch}) {
        let response = await axios.post('/auth/impersonate/stop')
        await dispatch('setToken', response.data.token)
    },
    logout({commit}) {
        localStorage.removeItem('token')
        commit('LOGOUT')
    },
    resetPassword({commit}, resetPassword) {
        commit('RESET_PASSWORD', resetPassword)
    },
    forgotPassword({commit}, forgotPassword) {
        commit('FORGOT_PASSWORD', forgotPassword)
    },
}

// mutations
const mutations = {
    LOGIN(state, payload) {
        state.usertoken = payload.token
    },
    LOGOUT(state) {
        state.usertoken = ''
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
